export const TEAM_NAME = 'Navigation';
